import React, { useState } from 'react';
import './Help.css'; // Make sure this path matches your file structure

const Help= () => {
  const [selectedIssue, setSelectedIssue] = useState('');

  const handleIssueChange =   (e) => {
    setSelectedIssue(e.target.value);
  };

  const handleSubmit = () => {
    if (selectedIssue) {
      alert(`You selected: ${selectedIssue} and Now we are redirecting to our FAQ Page. `);
      
    } else {
      alert('Please select an issue.');
    }
  };

  return (
    <div className="need-help-container">
      <h2>Still Need Help?</h2>
      <p>Tell us the issue you are facing.. !</p><br></br>
      <label htmlFor="issue-select">Select an issue:</label>
      <select id="issue-select" value={selectedIssue} onChange={handleIssueChange}>
        <option value="">--Please choose an option--</option>
        <option value="file-upload">File Upload Issue</option>
        <option value="login">Login Issues</option>
        <option value="score-documentation">Help with Score Documentation</option>
        <option value="general-enquiries">General Enquiries</option>
      </select>
      <label htmlFor="issue-select">Enter your Name:</label>
      
      <input id="issue-select"  type="text" name='Enter Your Name' />
      <br />
      <label htmlFor="issue-select">Enter Your Email ID:</label>
      <input id="issue-select"  type="email" name='Enter Your Email ID' /><br /><br />
      <button onClick={handleSubmit}>Submit</button>
    </div>
  );
};

export default Help;
